import dynamic from "next/dynamic";
import { useRouter } from "next/router";
import PropTypes from "prop-types";
import { getPageShellDataSafely } from "@/services/contenful/getPageShellDataSafe";

const Loader = dynamic(() => import("@/components/loader"));
const Landing = dynamic(() => import("@/components/landing"));

const LandingPage = ({ pageData = {} }) => {
  const router = useRouter();
  if (router.isFallback) {
    return <Loader loading={router.isFallback} />;
  }
  return <Landing pageData={pageData} />;
};

export async function getServerSideProps({ params, preview }) {
  const { slug = "/" } = params;
  const {
    items,
    headerNavigationData,
    footerNavigationData,
    promoBannerData,
    worldwideMenuData,
  } = await getPageShellDataSafely({
    slug: `/press-releases/${slug}`,
    preview,
    contentType: "brazilLandingPage",
    fetchEntryBySlugFlag: true,
  });

  const pageData = items?.[0]?.fields;
  if (!pageData) {
    return {
      notFound: true,
    };
  }

  return {
    props: {
      pageData,
      headerNavigationData,
      footerNavigationData,
      promoBannerData,
      world: worldwideMenuData,
    },
  };
}

LandingPage.propTypes = {
  pageData: PropTypes.object,
};

export default LandingPage;
